import { hashify } from "utils/hashify"

declare global {
    interface Window {
        advcake_data: unknown[]
    }
}

export function pushAdvCakeEvent(bookingId: string, email: string, price: number) {
    window.advcake_data = window.advcake_data || []
    window.advcake_data.push({
        pageType: 6,
        user: {
            email: hashify(email),
            type: "new",
        },
        leadInfo: {
            id: bookingId,
            leadid: "",
            name: "Заявка",
            totalPrice: price,
            coupon: "",
        },
    })
}
